import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ProductAdapter, OccEndpointsService, ConverterService, OccRequestsOptimizerService, Product, PRODUCT_NORMALIZER, ScopedProductData, ScopedDataWithUrl, Occ } from "@spartacus/core";
import { Observable } from "rxjs";
import { KB_PRODUCT_URL_NORMALIZER } from "src/app/app.module";

@Injectable()
export class KbOccProductAdapter implements ProductAdapter  {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected requestsOptimizer: OccRequestsOptimizerService
  ) {}

  load(productCode: string, scope?: string): Observable<Product> {
    return this.http
      .get(this.getEndpoint(productCode, scope))
      .pipe(this.converter.pipeable(PRODUCT_NORMALIZER),
       this.converter.pipeable(KB_PRODUCT_URL_NORMALIZER))     
  }

  encodingSlahWithPlus(productCode: string){
    return productCode.replace("/","@");

  }

  loadMany(products: ScopedProductData[]): ScopedProductData[] {
    const scopedDataWithUrls: ScopedDataWithUrl[] = products.map((model) => ({
      scopedData: model,
      url: this.getEndpoint(this.encodingSlahWithPlus(model.code), model.scope),
    }));
    

    return this.requestsOptimizer
      .scopedDataLoad<Occ.Product>(scopedDataWithUrls)
      .map(
        (scopedProduct) =>
          ({
            ...scopedProduct,
            data$: scopedProduct.data$?.pipe(
              this.converter.pipeable(PRODUCT_NORMALIZER),
              this.converter.pipeable(KB_PRODUCT_URL_NORMALIZER)
            )
          } as ScopedProductData)
      );
  }

  protected getEndpoint(code: string, scope?: string): string {
    return this.occEndpoints.buildUrl('product', {
      urlParams: { productCode: code },
      scope,
    });
  }
}
